// Short unique ids for nodes, layers, artboards, swatches. Random + a counter, so ids made in the same
// millisecond never collide; deterministic when seeded (tests).
let counter = 0;
let rng: () => number = Math.random;

export function newId(prefix = 'n'): string {
  counter = (counter + 1) % 0x10000;
  return `${prefix}_${Math.floor(rng() * 0x100000000).toString(36)}${counter.toString(36)}`;
}

/** Tests: make ids deterministic. */
export function seedIds(seed: number) {
  let s = seed >>> 0 || 1;
  counter = 0;
  rng = () => {
    s ^= s << 13;
    s ^= s >>> 17;
    s ^= s << 5;
    return (s >>> 0) / 0x100000000;
  };
}
